import { api } from '../api';
import { tags } from '../tags';
import type { ReferralVerification } from '../types';

/* istanbul ignore file */

export const referralVerifyApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    verifyReferral: builder.mutation<ReferralVerification, ReferralVerification>({
      query: (data) => ({
        url: 'api/referralverify/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [tags.referralVerification],
    }),

    reverifyReferral: builder.mutation<ReferralVerification, ReferralVerification>({
      query: (data) => ({
        url: `api/referralverify/${data.id}/`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: [tags.referralVerification],
    }),
  }),
});
